import axios from 'axios';

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptores 
api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('access_token');
    config.headers = config.headers || {};
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    } else {
      delete config.headers['Authorization'];
    }
    return config;
  },
  (error: unknown) => {
    const err = error instanceof Error
      ? error
      : new Error(typeof error === 'string' ? error : JSON.stringify(error));
    return Promise.reject(err); // o: throw err;
  }
);



api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: unknown) => {
    if (
      typeof error === "object" &&
      error !== null &&
      "response" in error &&
      (error as any).response?.status === 401
    ) {
      localStorage.clear();
      window.location.href = "/login";
    }

    console.error("API Error:", error);

    const err =
      error instanceof Error
        ? error
        : new Error(
            typeof error === "string" ? error : JSON.stringify(error)
          );

    return Promise.reject(err); // ✅ siempre un Error
  }
);
